import { InjectionToken } from '@angular/core';

import { FeatureFlagsService, FeatureFlagsProvider } from '@shure/shared/angular/utils/feature-flags';

import { FeatureFlagDynamicConfig, FeatureFlagIds } from './cloud-feature-flags-utils';

export class CloudFeatureFlagsService extends FeatureFlagsService<FeatureFlagIds, FeatureFlagDynamicConfig> {
	constructor(statsigProvider: FeatureFlagsProvider<FeatureFlagIds, FeatureFlagDynamicConfig>) {
		super([], undefined, statsigProvider);
	}
}

export function initializeFeatureFlagsService(
	statsigProvider: FeatureFlagsProvider<FeatureFlagIds, FeatureFlagDynamicConfig>
): CloudFeatureFlagsService {
	return new FeatureFlagsService<FeatureFlagIds, FeatureFlagDynamicConfig>([], undefined, statsigProvider);
}

export const FEATURE_FLAG_SERVICE = new InjectionToken<CloudFeatureFlagsService>('FeatureFlagService');
